<script>
export default {
  name: 'QualtricsRating',
  data() {
    return {
      qualtricsHeight: 0,
    };
  },

  mounted() {
    this.checkQualtrics();
  },

  methods: {
    checkQualtrics() {
      let qualtricsComponent = document.querySelector('.qualtrics-rating__container');
      setTimeout(() => {
        this.qualtricsHeight = this.$refs.content.offsetHeight;
        if (this.qualtricsHeight > 0) {
          qualtricsComponent.classList.add('qualtrics-rating--visible');
        } else if (this.qualtricsHeight < 52) {
          qualtricsComponent.classList.add('qualtrics-rating--hidden');
        }
      }, 5000);
      setTimeout(() => {
        if (qualtricsComponent.classList.contains('qualtrics-rating--hidden')) {
          qualtricsComponent.classList.remove('qualtrics-rating--hidden');
          this.qualtricsHeight = this.$refs.content.offsetHeight;
          if (this.qualtricsHeight > 0) {
          qualtricsComponent.classList.add('qualtrics-rating--visible');
          } else if (this.qualtricsHeight < 52) {
          qualtricsComponent.classList.add('qualtrics-rating--hidden');
          }
        }
      }, 10000);
    },
  },
};
</script>
